<script lang="ts" setup>
import Breadcrumb from '@/components/ui/breadcrumb/Breadcrumb.vue'
import { ref } from 'vue'
const crumbs = ref([
	{ name: 'Cadastro Zona de Exclusão', step: 0 },
	{ name: 'Definiçao da área', step: 1 },
])

const step = ref(1)
</script>

<template>
	<div class="h-full">
		<div
			style="display: flex"
			class="container__nav__revisao"
		>
			<breadcrumb
				:crumbs="crumbs"
				v-model="step"
				class="breadcrumb__internal"
			/>

			<slot name="actions" />
		</div>
		<div class="relative h-full">
			<slot />
		</div>
	</div>
</template>

<style scoped>
.container__nav__revisao {
	@apply justify-between px-8 py-2 items-center bg-white-neutral relative;
}
</style>
